import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CallButton from "../components/CallButton";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <CallButton />
      <Footer />
    </>
  );
}